'use strict';

var tracker = require('./tracking');
var $ = require('jquery');
var config = require('./config');

var $modalContainer = $('.share-modal-container');
var $modalContent = $modalContainer.find('.modal-content-container-inner');

var $closeModalButton = $('.modal-close');
var shareHash = '';
var firstChair = '';
var allChairs = '';
$closeModalButton.on('click', function() {
    hide();
});

$modalContainer.on('click', function() {
    hide();
});
$modalContent.on('click', function(e) {
    e.stopPropagation();
});




$('.modal-share-facebook').on('click', function() {
    tracker.trackShare('facebook');
    var link = config.getConfigData().share_base_url;

    window.open('https://www.facebook.com/sharer/sharer.php?u=' + link, 'Share on Facebook', 'width=600, height=600, scrollbars=no');
    return false;
});

$('.modal-share-twitter').on('click', function() {
    tracker.trackShare('twitter');

    var link = config.getConfigData().share_base_url;
    // link += '?chairs=' + shareHash;

    var msg = 'Herman Miller matched me with the {top}. Find the right chair for you at {link}.';
    msg = msg.replace('{top}', firstChair);
    msg = msg.replace('{link}', link);
    msg = encodeURI(msg);

    window.open('https://twitter.com/intent/tweet?text=' + msg, 'Share on Twitter', 'width=600, height=400, scrollbars=no');
});
$('.modal-share-linked').on('click', function() {
    tracker.trackShare('linkedin');
    // var link = config.getConfigData().share_base_url;

    var url = '';
    url += 'https://www.linkedin.com/shareArticle?mini=true';
    url += '&url=' + config.getConfigData().share_base_url;
    url += '&title=Herman Miller';
    url += '&summary=I\'ve been looking an office chair that fits me and supports my work. Herman Miller matched me with the {top}. Find the right chair for you at {link}.';

    url = url.replace('{top}', allChairs);
    url = url.replace('{link}', config.getConfigData().share_base_url);
// https://www.linkedin.com/shareArticle?mini=true&url=http://developer.linkedin.com&title=LinkedIn%20Developer%20Network
// &summary=My%20favorite%20developer%20program&source=LinkedIn
    window.open(url, 'Share on Linked In', 'width=600, height=400, scrollbars=no');
    // return false;
});

function hide() {
    $modalContainer.hide();
    $('body').removeClass('no-scroll');
}

function show(options) {
    $('body').addClass('no-scroll');
    $modalContainer.fadeIn('fast');
}
module.exports = {
    show: function(options) {
        show(options);
    },
    hide: function() {
        hide();
    },
    updateFirstChoiceChair: function(chairName) {
        firstChair = chairName;
    },
    updateChairTitles: function(chairTitles) {
        allChairs = chairTitles;
    },
    updateHash: function(hash) {
        console.log('share hash', hash);
        shareHash = hash;
    }
};
